import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";

export const launchApp = createViewerAction(ViewerMethod.LAUNCH_APP);
export const downloadApp = createViewerAction(ViewerMethod.DOWNLOAD_APP);
export const getDynamicUrl = createViewerAction(ViewerMethod.GET_DYNAMIC_URL);
export const getAppUrl = createViewerAction(ViewerMethod.GET_APP_SSO_URL);
